export default "__VITE_ASSET__acd52fcd__"